import { find } from 'lodash';
import {
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_DESCRIPTION,
  QUESTION_RATING,
  QUESTION_SLIDER,
  QUESTION_OPEN_ENDED,
  QUESTION_NUMERICAL_OPEN_ENDED,
  QUESTION_RANKING,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_VAN_WESTENDORP,
  QUESTION_MATRIX_MAXDIFF,
  ANSWER_OTHER,
  ANSWER_NONE_OF_THE_ABOVE,
  QUESTION_MATRIX_BIPOLAR,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_OPEN_ENDED_NUMERIC,
  QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM,
} from '../../constants';
import {
  getAnswersShuffleType,
  shuffleArray,
  getCarriedForwardAnswers,
} from '../../utils';

export const getAnswerClass = ({
  question,
  answer = {},
  containsOnlyEmoji,
}) => {
  let answerClass = '';

  switch (question.style) {
    case QUESTION_MULTIPLE:
    case QUESTION_MATRIX_MAXDIFF:
      answerClass = 'multi-choice';
      break;
    case QUESTION_DESCRIPTION:
    case QUESTION_RATING:
    case QUESTION_SLIDER:
    case QUESTION_OPEN_ENDED:
    case QUESTION_NUMERICAL_OPEN_ENDED:
      answerClass = 'hidden';
      break;
    case QUESTION_RANKING:
    case QUESTION_MATRIX_SINGLE:
    case QUESTION_MATRIX_MULTIPLE:
    case QUESTION_MATRIX_VAN_WESTENDORP:
      answerClass = 'multi-choice hidden';
      break;
    default:
      answerClass = 'single-choice';
  }

  if (answer.style === ANSWER_NONE_OF_THE_ABOVE) {
    answerClass =
      question.style === QUESTION_SINGLE ? 'single-choice' : 'multi-choice';
    answerClass += ' none-of-the-above';
  }

  if (answer.style === ANSWER_OTHER) {
    answerClass += ' answer-other';
  }

  if (question.f_name === 'dg_year_of_birth') {
    answerClass = 'single-choice hidden';
  }

  if (containsOnlyEmoji) {
    answerClass += ' contains-only-emoji';
  }

  if (answer.isCarriedForward === true) {
    answerClass += ' carry-forward-inline';
  }

  if (answer.isExclusive === true) {
    answerClass += ' exclusive-answer';
  }

  return `answer--${answerClass}`;
};

// this one applies only for matrix type questions
export function getGenericShuffleType(question) {
  const isMatrix =
    question.style === QUESTION_MATRIX_SINGLE ||
    question.style === QUESTION_MATRIX_MULTIPLE ||
    question.style === QUESTION_MATRIX_BIPOLAR ||
    question.style === QUESTION_MATRIX_OPEN_ENDED ||
    question.style === QUESTION_MATRIX_OPEN_ENDED_NUMERIC ||
    question.style === QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM;
  if (isMatrix) {
    return getAnswersShuffleType(question.shuffle);
  }

  return question.shuffle;
}

export function shuffleAnswers(question) {
  const answers = [...question.answers];

  const carriedForwardAnswers = getCarriedForwardAnswers(question);

  const filteredAnswers = carriedForwardAnswers.filter(
    (answer) =>
      answer.style !== ANSWER_OTHER &&
      answer.style !== ANSWER_NONE_OF_THE_ABOVE,
  );
  const otherAnswer = find(answers, ['style', ANSWER_OTHER]);
  const noneOfTheAboveAnswer = find(answers, [
    'style',
    ANSWER_NONE_OF_THE_ABOVE,
  ]);

  const shuffleType = getGenericShuffleType(question);
  const returnedAnswers = shuffleArray(filteredAnswers, shuffleType);

  if (otherAnswer) {
    returnedAnswers.push(otherAnswer);
  }

  if (noneOfTheAboveAnswer) {
    returnedAnswers.push(noneOfTheAboveAnswer);
  }

  return returnedAnswers;
}
